if (!customElements.get('sonic-science-popover')) {
  customElements.define('sonic-science-popover', class extends HTMLElement {
    constructor() {
      super();
      this.onBeforeToggle = (event) => {
        if (event.newState === 'closed') {
          this.querySelectorAll('video').forEach(video => video.pause());
        } else {
          this.loadImages();
        }
      };
    }

    loadImages() {
      this.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
    }

    connectedCallback() {
      this.addEventListener('beforetoggle', this.onBeforeToggle);
      const scene = this.closest('.sonic-comparison-2__product');
      if (scene && typeof IntersectionObserver === 'function') {
        this.mediaObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.loadImages();
            this.mediaObserver.disconnect();
          }
        }, { rootMargin: '300px' });
        this.mediaObserver.observe(scene);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('beforetoggle', this.onBeforeToggle);
      this.mediaObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
